import * as React from 'react';
import {useLocation} from 'react-router-dom';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import TopBar from '../components/TopBar';
import DashboardComponent from '../components/DashboardComponent';
import FiveDayTable from '../components/FiveDayTable';
import DataManager from '../components/DataManager';
import {DASHBOARD, DATA_MANAGER, FIVE_DAY_NOTICE} from '../resources/constants/ComponentList';
import Colors from '../resources/constants/Colors.json';
import API_CONSTANTS from '../resources/constants/api.json';

export default function Dashboard(props) {
    const useState = React.useState;
    const useEffect = React.useEffect;
    const theme = useTheme();
    console.log('dashboardProps', props)
    let dttm = new Date(Date.now());
    const runDate = dttm.getFullYear() + '-' + (dttm.getMonth()+1)
    const [runDateList, setRunDateList] = useState([])
    const [rowJson, setRowJson] = useState([])
    const location = useLocation();


    useEffect(()=>{
        if (!rowJson){
            fetch(`${API_CONSTANTS.API_ROUTE}/getRundates`)
            .then((response) => {
                response.json().then(data => {
                    setRunDateList(data);
                })
            })

            fetch(`${API_CONSTANTS.API_ROUTE}/fiveDayNotices?run_date=${runDate}`)
            .then((response) => {
                response.json().then(data => {
                    setRowJson(data);
                })
            })
        }
    },[])

    const [selectedPage, setSelectedPage] = useState(FIVE_DAY_NOTICE);

    const formatUserName = (email) => {
        email = email.split('@')[0];
        return email.slice(0,2).toUpperCase() + email.slice(2,email.length)
        
    }

    const userInfo = {...location.state[0], userName: formatUserName(location.state[0].email)}

    const loadComponent = () => {
        if (selectedPage === DASHBOARD) return (<DashboardComponent rowJson={rowJson} setRowJson={setRowJson} runDateList={runDateList} runDate={runDate} userInfo={userInfo}/>)
        if (selectedPage === DATA_MANAGER) return (<DataManager runDateList={runDateList} runDate={runDate} userInfo={userInfo}/>)
        if (selectedPage === FIVE_DAY_NOTICE) return (<FiveDayTable rowJson={rowJson} setRowJson={setRowJson} runDateList={runDateList} runDate={runDate} userInfo={userInfo}/>)
    }

    return (
        <Box sx={{
            backgroundColor: theme.palette.background.default,
            minHeight: '100vh',
            height: '100%',
            paddingLeft: '1%',
            paddingRight: '1%'
        }}>
            <Box>
                <TopBar
                    userName={userInfo.userName}
                    runDate={runDate}
                    menuItems={['Dashboard', 'Data Manager', 'Five Day Notice']}
                    parent={selectedPage}
                    setSelectedPage={setSelectedPage}
                />
            </Box>
            <Box sx={{marginTop:3}}>
                {loadComponent()}
            </Box>
            <div>version: </div>
        </Box>
    )
}